import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import db from "../../db/db";
import { makeStyles, withStyles } from "@mui/styles";
import { blue, orange, red, yellow } from "@mui/material/colors";
import { AgentUtils } from "../../utils/AgentUtils";
import { useTranslation } from "react-i18next";
import PricingSelector from "./PricingSelector";

const DeptButton = withStyles((theme) => ({
  root: {
    width: "100%",
    height: "45px",
    fontSize: "0.7rem",
    color: theme.palette.getContrastText(yellow[500]),
    backgroundColor: "#ccccfe",
    "&:hover": {
      backgroundColor: yellow[700],
    },
  },
}))(Button);

const ItemButton = withStyles((theme) => ({
  root: {
    width: "100%",
  },
}))(Button);

export default function ProductTileView(props) {
  const { t, i18n } = useTranslation();
  const translate = t;

  const [depts, setDepts] = useState([]);
  const [selectedDept, setSelectedDept] = useState({ name: null });
  const [selectedProduct, setSelectedProduct] = useState();
  const [showPricingSelector, setShowPricingSelector] = useState(false);

  const [products, setProducts] = useState([]);

  useEffect(() => {
    initScreen();
  }, []);

  useEffect(() => {
    if (selectedDept && selectedDept.name) {
      console.log(selectedDept);
      populateProducts(selectedDept);
    }
  }, [selectedDept]);

  async function populateProducts(dept) {
    let products = await db.product.where("deptId").equals(dept.id).toArray();

    setProducts(products);
  }

  async function initScreen() {
    let deptData = await db.category.where("level").equals(0).toArray();
    let dd = [];
    let i = 0;
    let sd = null;
    for (let d of deptData) {
      if (i == 0) sd = d;
      dd.push(d);
      i++;
    }
    setDepts(dd);
    setSelectedDept(sd);
  }

  return (
    <Grid container style={{ padding: 5 }}>
      <Grid item xs={4}>
        <Grid
          container
          style={{
            padding: 2,
          }}
        >
          <Grid
            item
            xs={12}
            style={{
              background: "rgb(25 118 210)",
              color: "white",
              paddingLeft: 5,
            }}
          >
            {translate("Department")}
          </Grid>
          <Grid item xs={12}>
            <div
              style={{
                height:
                  AgentUtils.getWindowDimensionsExAppBars().h +
                  (props.context.appType === "R_POS" ? -170 : 35),
                overflow: "auto",
                display: "block",
                background: "#eee",
              }}
            >
              <Grid container>
                {depts.map(
                  (item) =>
                    item && (
                      <Grid
                        item
                        xs={props.context.appType === "R_POS" ? 6 : 12}
                        style={{ padding: 3 }}
                      >
                        <DeptButton
                          style={{
                            fontSize: "0.7rem",

                            textTransform: "none",
                            backgroundColor:
                              item.name === selectedDept.name
                                ? orange[500]
                                : "#ccccfe",
                          }}
                          onClick={() => {
                            setSelectedDept(item);
                          }}
                        >
                          {item.name}
                        </DeptButton>
                      </Grid>
                    )
                )}
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={8}>
        <Grid
          container
          style={{
            padding: 2,
          }}
        >
          <Grid
            item
            xs={12}
            style={{
              background: "rgb(25 118 210)",
              color: "white",
              paddingLeft: 5,
            }}
          >
            {translate("Items")}
          </Grid>
          <Grid item xs={12}>
            <div
              style={{
                height:
                  AgentUtils.getWindowDimensionsExAppBars().h +
                  (props.context.appType === "R_POS" ? -170 : 35),
                overflow: "auto",
                display: "block",
                background: "#ddd",
              }}
            >
              <Grid container>
                {products.map(
                  (item) =>
                    item && (
                      <Grid
                        item
                        xs={props.context.appType === "R_POS" ? 4 : 6}
                        style={{ padding: 3 }}
                      >
                        <ItemButton
                          style={{
                            backgroundColor: "#ffffcb",
                            fontSize: "0.65rem",
                            padding: "2px",
                            paddingLeft: "5px",
                            height: "50px",
                            textTransform: "none",
                          }}
                          onClick={() => {
                            if (item.productPricingBeanList.length > 1) {
                              setSelectedProduct(item);
                              setShowPricingSelector(true);
                            } else {
                              props.onAddProduct(
                                item,
                                item.productPricingBeanList[0]
                              );
                            }
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                              height: "45px",
                            }}
                          >
                            <Grid container>
                              <Grid item xs={12}>
                                {item.name}
                              </Grid>
                              <Grid item xs={12} style={{ color: blue[900] }}>
                                {item.productPricingBeanList.length == 1
                                  ? item.productPricingBeanList[0].price
                                  : ""}
                              </Grid>
                            </Grid>
                          </div>
                        </ItemButton>
                      </Grid>
                    )
                )}
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Grid>
      {showPricingSelector && (
        <PricingSelector
          closeWindow={setShowPricingSelector}
          product={selectedProduct}
          onAddProduct={props.onAddProduct}
        ></PricingSelector>
      )}
    </Grid>
  );
}
